
const defaultState = function () {
  return {
    returnList: false, // オペレーションボタンから編集モードに遷移したか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'order_list',
    // 検索条件
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getDefaultState: defaultState
}
